<template>
  <v-container fluid v-editable="blok" class="ma-0 pa-0">
    <v-sheet
      class="banner-container"
      :style="`background-image: url('${blok.image}');`"
      tile
      height="400"
    >
      <div class="bg"></div>
      <v-container fluid v-editable="blok" class="ma-0 fill-height">
        <v-row justify="start" align="start" >
          <v-col cols="12" class="text-left">
            <div class="title mb-5">
              <div class="pb-icon">
                <div class="before">
                  <span>◄</span>
                </div>
                <figure>
                  <img src="@/assets/logo_mini.svg" alt />
                </figure>
              </div>
              <h2>{{blok.title}}</h2>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
  </v-container>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ["blok"]
};
</script>

<style lang="scss" scoped>
@import "./MainBanner.scss";
</style>